import React from "react";
import type { NavigationItem } from "@/routers/types";
import { getSidebarConfig } from "./utils";

export interface SidebarChild {
  title: string;
  url: string;
  breadcrumb?: string;
  children?: SidebarChild[];
}

export interface SidebarItem {
  title: string;
  url: string;
  icon: React.ReactNode;
  breadcrumb?: string;
  children?: SidebarChild[];
}

export interface SidebarGroup {
  group: React.ReactNode;
  items: SidebarItem[];
}

const convertChildren = (children: NavigationItem[]): SidebarChild[] => {
  return children
    .filter((child) => child.showInSidebar !== false)
    .map((child) => ({
      title: child.title,
      url: child.path,
      breadcrumb: child.breadcrumb,
      children: child.children ? convertChildren(child.children) : undefined,
    }));
};

const generateSidebarItems = (): SidebarGroup[] => {
  const sidebarItems = getSidebarConfig();

  const items: SidebarItem[] = sidebarItems.map((item) => {
    const hasDuplicateChildPath = Array.isArray(item.children)
      ? item.children.some((child) => child.path === item.path)
      : false;
    const parentUrl = hasDuplicateChildPath ? `#${item.path}` : item.path;

    return {
      title: item.title,
      url: parentUrl,
      icon: item.icon || React.createElement("span"),
      breadcrumb: item.breadcrumb,
      children: item.children ? convertChildren(item.children) : undefined,
    };
  });

  return [
    {
      group: React.createElement("span"),
      items,
    },
  ];
};

export { findNavigationItem } from "./utils";

export const getSidebarItems = (): SidebarGroup[] => generateSidebarItems();

export const getMenuItems = () => {
  const freshSidebarItems = getSidebarItems();
  return freshSidebarItems[0].items;
};
